/**
 *
 * @param {*} salePrice
 * @param {*} costPrice
 * @param {*} fixed
 * @param {*} margin
 */
const getMargin = function(salePrice, costPrice, fixed = 2, margin = 0.0) {
    //
    const cost = parseFloat(costPrice),
        sale = parseFloat(salePrice)

    //
    if (numberArePositive(sale, cost)) {
        //
        if (cost <= sale) {
            margin = (sale * 100) / cost - 100
        }
    }

    //
    return margin.toFixed(fixed)
}

/**
 *
 * @param {*} salePrice
 * @param {*} costPrice
 * @param {*} gain
 */
const getGain = function(salePrice, costPrice, gain = 0) {
    //
    const cost = parseFloat(costPrice),
        sale = parseFloat(salePrice)

    //
    if (cost <= sale) {
        //
        gain = cost - sale
    }

    //
    return gain
}

const getSalePrice = function(costPrice, margin) {
    let salePrice = 0
    if (costPrice > 0 && margin > 0) {
        salePrice = costPrice + costPrice * (margin / 100)
    }
    return salePrice
}

const getSaleWithCostGain = function(cost, gain) {
    return cost + gain
}

const numberArePositive = function(number1, number2) {
    if (Math.sign(number1) === 1 && Math.sign(number2) === 1) {
        return true
    } else {
        return false
    }
}

const priceWithDiscount = function(price, percentage) {
    if (numberArePositive(price, percentage)) {
        if (percentage > 0 && percentage < 101) {
            let discount = price * (percentage / 100)
            return Math.round(price - discount)
        }
        return price
    } else {
        if (percentage == 0 || percentage == null) {
            return price
        }
        return 0
    }
}

const getNetPrice = salePrice => (salePrice / 1.19).toFixed(2)

const getNewMargin = (salePrice, costPrice) => {
    if (numberArePositive(salePrice, costPrice)) {
        let netPrice = getNetPrice(salePrice)
        let result = (((netPrice - costPrice) / costPrice) * 100).toFixed(2)
        return result
    } else {
        return 0
    }
}

export default {
    getMargin,
    getGain,
    getSalePrice,
    getSaleWithCostGain,
    priceWithDiscount,
    getNetPrice,
    getNewMargin,
}
